import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
// import ReferralView from "./referrelview";
import {
  EditIcon,
  // ReferralIcon,
} from "@/assets/icons/admin";
import { useGetAllBalances } from "@/services/admin.service";
import { format } from "date-fns";
import Datatable from "@/components/tables/datatable";
import { AdjustBalanceDialog } from "./adjustBalanceModal";

const fields = [
  { label: "Username", value: "userName" },
  { label: "Email", value: "email" },
  { label: "Last IP", value: "lastIP" },
];

const columns = [
  {
    key: "no",
    label: "No",
  },
  {
    key: "userName",
    label: "Username",
    sortable: true,
  },
  {
    key: "email",
    label: "Email",
    sortable: true,
  },
  {
    key: "accountBalance",
    label: "Balance",
    sortable: true,
    align: "end",
  },
  {
    key: "nativeToken",
    label: "SHRL Balance",
    sortable: true,
    align: "end",
  },
  {
    key: "action",
    label: "Action",
    sortable: true,
  },
];

export const PlayerBalances = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({
    id: "",
    userName: "",
  });
  const [refetch, setRefetch] = useState(false);

  const query = useGetAllBalances;

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "action":
        return (
          <div className="flex items-center">
            <Button
              onClick={() => {
                setSelectedUser({
                  id: item?.id,
                  userName: item?.userName,
                });
                setIsModalOpen(true);
              }}
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <EditIcon />
            </Button>
          </div>
        );
      case "no":
        return (
          <div className="">
            {data.findIndex(
              (row: any) => (row as any)?.id === (item as any)?.id,
            ) + 1}
          </div>
        );
      case "accountBalance":
        return (
          <div className="text-right">
            $
            {item?.accountBalance.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        );
      case "nativeToken":
        return (
          <div className="text-right">
            {item?.nativeToken.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximuFractionDigits: 2,
            })}
          </div>
        );
      case "updatedAt":
        return (
          <div className="w-max">
            <div>
              {format(item?.createdAt || new Date(), "dd/MM/yyyy HH:mm:ss")}
            </div>
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      <div className="font-ubuntu float-left text-center text-sm font-semibold text-white sm:text-lg">
        <p className="hidden sm:block">Player Balances</p>
      </div>
      <Datatable
        columns={columns}
        renderCell={renderCell}
        query={query}
        defaultRowsPerPage={"100"}
        searchFields={fields}
        triggerRefetch={refetch}
        onRefetch={() => setRefetch(false)}
      />
      <AdjustBalanceDialog
        userId={selectedUser.id}
        userName={selectedUser.userName}
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(!isModalOpen);
        }}
        onRefetch={() => {
          setRefetch(true);
        }}
      />
    </div>
  );
};
